export default __webpack_public_path__ + "static/amos_logo-c266b44c37e9ca913286dcb45a0e6b93.png";